// extracted by mini-css-extract-plugin
module.exports = {"button":"_2nzAELVU0TYBn5c_qSdS7C","icon":"_397hG44s6v3km6atmaGN9S"};